import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';

import NoticeDeleteModal from './NoticeDeleteModal';
import NewNoticeViewBox from './NewNoticeViewBox';

function NoticeView(props) {
  const { noticeId } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const [data, setData] = useState({
    title: '',
    content: '',
    pictures: '',
    commentList: []
  });
  const [deleteClick, setDeleteClick] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [rendering, setRendering] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    let requestData = {
      noticeId: noticeId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('notice/detail/zone', 'POST', requestData);
        if (responseData.status === 200) setData(responseData.data[0]);
        else if (responseData.status === 401) history.push('/');

        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    )();
  }, [history, noticeId, rendering])

  function modifyNoticeClick() {
    history.push('/notice/modify/' + noticeId);
  }

  return (
    <TopLevelWrapper>
      {deleteClick && <NoticeDeleteModal noticeId={noticeId} exitClickFn={() => setDeleteClick(false)}/>}
      <TopBarWrapper>
        <TextWrapper>
          <Title>{t('noticePage.title')}</Title>
          <Explanation>{t('noticePage.description')}</Explanation>
        </TextWrapper>
        <ButtonWrapper>
          <ExitButton onClick={() => setDeleteClick(true)}>{t('noticePage.delete')}</ExitButton>
          <AddButton onClick={modifyNoticeClick}>{t('noticePage.modify')}</AddButton>
        </ButtonWrapper>
      </TopBarWrapper>
        <NewNoticeViewBox
          data={data} 
          title={data.title} 
          defaultVal={data.details} 
          noticeId={noticeId} 
          storeLogo={data.storeLogo}
          isFixed={data.isFixed}
          rendering={() => setRendering(!rendering)}
          isLoading={isLoading}/>
    </TopLevelWrapper>
  )
}

export default NoticeView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 42px;

  transition: all 0.3s ease-in-out;
`;

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 992px;

  margin-left: 28px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 15px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  transition: all 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.subText};
    color: ${props => props.theme.subText};
  }
`;

const AddButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.subKeyHover};
    }
  }
`;
